import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

const Join = () => {
  const [currentCard, setCurrentCard] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const cardRef = useRef(null);

  const guidelines = [
    {
      title: "1. Club Purpose",
      content: (
        <>
          <p>The purpose of this Club shall be to provide for its members:</p>
          <ul>
            <li>A well-maintained and safe aircraft.</li>
            <li>A convenient means for flying at the most economical rates.</li>
            <li>Friendship and fellowship through a group commitment to aviation and safety.</li>
          </ul>
        </>
      )
    },
    {
      title: "2. New Members",
      content: (
        <>
          <p>New members shall:</p>
          <ul>
            <li>At no time, be discriminated against on the basis of age, sex, religion or national origin.</li>
            <li>Be limited to ten (10) members for each aircraft.</li>
            <li>Pay a $6100.00 membership fee that is conditionally refundable as outlined in Para #6.</li>
          </ul>
        </>
      )
    },
    {
      title: "3. Continuing Membership Requirements",
      content: (
        <>
          <p>Continuing membership requires that each member shall:</p>
          <ul>
            <li>Foster and maintain an atmosphere of friendly cooperation among all Club members.</li>
            <li>Observe and comply with all Club Flight Rules and Federal Aviation Regulations.</li>
            <li>Attend at least 2 Club meetings per year.</li>
            <li>Participate several times annually in the cleaning and maintenance of the aircraft and hangar.</li>
          </ul>
        </>
      )
    },
    {
      title: "5. Withdrawal of Membership",
      content: (
        <ul>
          <li>A member may withdraw from the Club upon notification to the President in writing thirty (30) days in advance.</li>
          <li>Any member withdrawing is accorded a refund of dues paid in advance of the current quarter.</li>
        </ul>
      )
    },
    {
      title: "6. Membership Fee Refund Policy",
      content: (
        <>
          <p>Membership fee shall be refunded as follows provided the member:</p>
          <ul>
            <li>Has no outstanding balance - to include, but not limited to, flight time or repairs.</li>
            <li>$5000, with at least a 4-year minimum membership.</li>
            <li>If less than 4 years when withdrawing, $4,000 is refunded.</li>
            <li>An additional $750 deduction will be made if any training for a rating is involved.</li>
          </ul>
        </>
      )
    }
  ];

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe && currentCard < guidelines.length - 1) {
      setCurrentCard(prev => prev + 1);
    }
    if (isRightSwipe && currentCard > 0) {
      setCurrentCard(prev => prev - 1);
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'ArrowRight' && currentCard < guidelines.length - 1) {
      setCurrentCard(prev => prev + 1);
    }
    if (e.key === 'ArrowLeft' && currentCard > 0) {
      setCurrentCard(prev => prev - 1);
    }
  }, [currentCard, guidelines.length]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div className="page-container">
      <h1 className="page-title">Join Our Club</h1>
      <div className="page-content">
        <section className="membership-guidelines">
          <h2>Membership Guidelines</h2>
          <p className="guidelines-intro">Our Membership Guidelines are based on the AOPA model from 1996. Swipe through the cards to learn more.</p>
          
          <div 
            className="guidelines-carousel"
            ref={cardRef}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <div className="guidelines-card">
              <h3>{guidelines[currentCard].title}</h3>
              {guidelines[currentCard].content}
            </div>
            
            <div className="carousel-controls">
              <button 
                className="carousel-button prev"
                onClick={() => currentCard > 0 && setCurrentCard(prev => prev - 1)}
                disabled={currentCard === 0}
              >
                ←
              </button>
              <div className="carousel-indicators">
                {guidelines.map((_, index) => (
                  <span 
                    key={index} 
                    className={`indicator ${currentCard === index ? 'active' : ''}`}
                    onClick={() => setCurrentCard(index)}
                  />
                ))}
              </div>
              <button 
                className="carousel-button next"
                onClick={() => currentCard < guidelines.length - 1 && setCurrentCard(prev => prev + 1)}
                disabled={currentCard === guidelines.length - 1}
              >
                →
              </button>
            </div>
          </div>
        </section>

        <section className="join-cta">
          <h2>Ready to Join?</h2>
          <p>If you're interested in becoming a member, please contact us for more information and to schedule a meeting.</p>
          <Link to="/contact" className="cta-button">Contact Us</Link>
        </section>
      </div>
    </div>
  );
};

export default Join; 